/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithKindItemRequestBuilder, WithKindItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/vendors/{vendorCode}/images
 */
export interface ImagesRequestBuilder extends BaseRequestBuilder<ImagesRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.vendors.item.images.item collection
     * @param kind Which picture: logo or lifestyle.
     * @returns {WithKindItemRequestBuilder}
     */
     byKind(kind: string) : WithKindItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const ImagesRequestBuilderUriTemplate = "{+baseurl}/api/vendors/{vendorCode}/images";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ImagesRequestBuilderNavigationMetadata: Record<Exclude<keyof ImagesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byKind: {
        requestsMetadata: WithKindItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["kind"],
    },
};
/* tslint:enable */
/* eslint-enable */
